import { FC, useState } from "react";
import { cn } from "@/libs/utils";
import { useTrans } from "src/utils/useTrans";
import CloseIcon from "@/v2-components/core/icon/close-icon";

type SortOption = { value: string; labelKey: string };

type Props = {
  className?: string;
  categories: string[];
  current: string;
  onClose: (e: any) => void;
  onSelectCategory: (category: string) => (e: any) => void;
  sortBy: string;
  sortOptions: SortOption[];
  onSelectSort: (value: string) => void;
};

const SelectCategoryOnMobile: FC<Props> = ({
  className = "",
  onSelectCategory,
  onClose,
  categories,
  current,
  sortBy,
  sortOptions,
  onSelectSort,
}) => {
  const { t } = useTrans(["support"]);
  const [chosen, setChosen] = useState<string>(current);
  const [chosenSort, setChosenSort] = useState<string>(sortBy);

  const updateChosen = (category: string) => (e: any) => {
    setChosen(category);
  };

  return (
    <div
      className={
        "flex h-full w-full flex-col justify-end overflow-y-hidden text-[#212630]"
      }
    >
      <div className={"flex self-end px-4 py-4"}>
        <button onClick={onClose}>
          <CloseIcon className="size-6 text-black" />
        </button>
      </div>
      <div className={"flex-grow overflow-y-auto px-5"}>
        {/* 정렬 */}
        <p className={"mt-2.5 py-2 text-sm font-700 opacity-50"}>
          {t("Sort by")}
        </p>
        {sortOptions.map((opt) => {
          const ischosen = opt.value === chosenSort;
          return (
            <div key={opt.value} className={"flex h-[60px] flex-col"}>
              <div
                onClick={() => setChosenSort(opt.value)}
                className={cn(
                  ischosen ? "opacity-100" : "opacity-60",
                  "flex cursor-pointer items-center justify-between py-4 active:opacity-75",
                )}
              >
                <span className={"text font-700 capitalize"}>
                  {t(opt.labelKey)}
                </span>
              </div>
              <span
                className={"inline-block h-px w-full bg-[#212630] opacity-10"}
              />
            </div>
          );
        })}
        {/* 카테고리 */}
        <p className={"mt-6 py-2 text-sm font-700 opacity-50"}>
          {t("Choose a category")}
        </p>
        <div className={"mt-2.5"}>
          {!!categories.length &&
            categories.map((value: any, index) => {
              const ischosen = value === chosen;
              return (
                <div key={index} className={"flex h-[60px] flex-col"}>
                  <div
                    onClick={updateChosen(value)}
                    className={cn(
                      ischosen ? "opacity-100" : "opacity-60",
                      "flex cursor-pointer items-center justify-between py-4 active:opacity-75",
                    )}
                  >
                    <span className={"text font-700 capitalize"}>
                      {t(`${value}`)}
                    </span>
                  </div>
                  <span
                    className={
                      "inline-block h-px w-full bg-[#212630] opacity-10"
                    }
                  />
                </div>
              );
            })}
        </div>
      </div>
      <button
        onClick={(e: any) => {
          onSelectCategory(chosen)(e);
          onSelectSort(chosenSort);
          onClose(e);
        }}
        className={cn(
          "h-[60px] w-full bg-[#222222] text-[17px] font-700 text-white",
        )}
      >
        <span>{t("DONE")}</span>
      </button>
    </div>
  );
};

export default SelectCategoryOnMobile;
